<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2019年12月25日 14:32:56 +0800
 * @最后修改时间: 2022-03-07 14:17:51
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimItemType\editClaimItemType.vue
 -->
<template>
  <ContentLayout
    widthClass="max-1000"
    :title="
      iSEdited
        ? $t('label_essweb_ClaimItemType_form_editTitle')
        : $t('label_essweb_ClaimItemType_form_viewTitle')
    "
    backgroundClass="white"
    :editBtn="!iSEdited"
    :initData="claimItemType"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'claim_item_type_name',
      'sequence',
      'status',
      'claim_item_type_description',
      'max_value',
      'min_value',
      'remarks',
    ]"
    delBtn
    @delete="
      $confirmDo($t('label_essweb_ClaimItemType_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
    @edit="iSEdited = true"
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-switch
              :disabled="!iSEdited"
              color="primary"
              class="ml-4"
              v-model="claimItemType.status"
              :label="
                claimItemType.status
                  ? $t('label_essweb_ClaimItemType_form_activeLabel')
                  : ''
              "
            ></v-switch>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="claimItemType.claim_item_type_name"
              maxlength="200"
              @change="
                (valueArr) => {
                  claimItemType.claim_item_type_name = valueArr;
                }
              "
              :label="
                $t('label_essweb_ClaimItemType_form_claimItemTypeNameLabel')
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>

          <v-col :md="iSEdited ? 3 : 6">
            <numberInputTextFiled
              :filled="iSEdited"
              maxlength="11"
              :readonly="!iSEdited"
              :rules="
                $GetRules(['_Number_negative', '_Length_Rules'], [null, 11])
              "
              v-model="claimItemType.sequence"
              :label="$t('label_essweb_ClaimItemType_form_sequenceLabel')"
              isNotRequire
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="claimItemType.claim_item_type_description"
              maxlength="500"
              @change="
                (valueArr) => {
                  claimItemType.claim_item_type_description = valueArr;
                }
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="$t('label_essweb_ClaimItemType_form_descriptionLabel')"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :filled="iSEdited"
              :readonly="!iSEdited"
              v-model="claimItemType.min_value"
              :rules="$GetRules(['_Number_negative'], [null])"
              :label="$t('label_essweb_ClaimItemType_form_minValueLabel')"
              type="number"
              :max="5"
              isNotRequire
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :filled="iSEdited"
              :readonly="!iSEdited"
              :min="claimItemType.min_value"
              v-model="claimItemType.max_value"
              :rules="$GetRules(['_Number_negative'], [null])"
              :label="$t('label_essweb_ClaimItemType_form_maxValueLabel')"
              type="number"
              isNotRequire
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_ClaimItemType_form_remarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              :filled="iSEdited"
              :readonly="!iSEdited"
              no-resize
              maxlength="500"
              counter="500"
              dense
              single-line
              v-model="claimItemType.remarks"
              name="input-7-4"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        saveBtn
        @save="toSave"
        @cancel="$toBack(isChanged)"
        v-if="iSEdited"
      />
    </template>
    <!-- actions -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "editClaimItemType",
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  data() {
    return {
      iSEdited: true,
      isChanged: false,
      claimItemType: {
        claim_item_type_name: "",
        sequence: 1,
        status: 0,
        is_relate_to_cost_center: 0,
        claim_item_type_description: "",
        max_value: 0,
        min_value: 0,
        remarks: "",
      },
    };
  },
  watch: {},
  mounted() {
    const that = this;
    // this.claimItemType.claim_item_type_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.claimItemType.claim_item_type_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.getDetail();
  },
  methods: {
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_item_type",
        url: "/claim-item-type/delete/",
        data: { uuids: this.$route.params.id },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_ClaimItemType_list_deleteClaimItemTypeSuccessLabel"
          ),
          type: "success",
        });
        that.$toBack();
      });
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_item_type",
        url: "/claim-item-type/get-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data["claim_item_type_name_save"] = res.data.claim_item_type_name;
        res.data.claim_item_type_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.claim_item_type_name
        );
        res.data["claim_item_type_description_save"] =
          res.data.claim_item_type_description;
        res.data.claim_item_type_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.claim_item_type_description
        );
        res.data.status = Number(res.data.status);
        that.claimItemType = res.data;
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_item_type",
        url: "/claim-item-type/update/",
        data: {
          uuid: this.$route.params.id,
          claim_item_type_name: this.$transCommonLangKey(
            this.claimItemType.claim_item_type_name,
            this.claimItemType.claim_item_type_name_save
          ),
          claim_item_type_description: this.$transCommonLangKey(
            this.claimItemType.claim_item_type_description,
            this.claimItemType.claim_item_type_description_save
          ),
          max_value: this.claimItemType.max_value,
          min_value: this.claimItemType.min_value,
          status: this.claimItemType.status ? 1 : 0,
          sequence: this.claimItemType.sequence,
          remarks: this.claimItemType.remarks,
        },
      }).then((res) => {
        that.$showMessage({
          color: "success",
          text: that.$t(
            "message_essweb_ClaimItemType_list_updateClaimItemTypeSuccessLabel"
          ),
          type: "success",
        });
        that.$toBack(); //回到不能编辑状态
      });
    },
  },
};
</script>
